<template>
  <div class="lg:py-8 lg:container lg:mx-auto">
    <PopUpsStoreFinder class="bg-white" @store-changed="assignStore"/>
  </div>
</template>
<script setup lang="ts">
const route = useRoute();
const logger = useLogger('store-finder-page');

const isEmbedded = useEmbedded();

async function assignStore(storeId: string) {
  if (route?.query?.redirecturl) {
    const response: string = await $fetch('/api/neo/frontend/_api/storeFinder/assignStore', {
      method: "POST",
      body: {
        storeId: storeId,
        redirectUrl: route?.query?.redirecturl,
      },
      headers: {
        'csrf-token': useCurrentUserState()?.value?.csrfToken || '',
        'bt-use-user-auth': 'true'
      },
      server: false,
    });

    if (response && typeof response === 'string') {
      try {
        const redirectUrl: URL = new URL(response);
        navigateTo(redirectUrl.pathname, { external: !redirectUrl.pathname.startsWith('/shop'), open: {
          target: isEmbedded.value ? '_top' : '_self'
        } });
      } catch (error) {
        logger.error(error);
      }
    }
  }
}
</script>